import { Heading, Table } from '@msaf/core-react'
import { FeatureAction } from '../../../../components/pdf/types'
import { getCollectionAggregateForProperty, getPlantingTypeSummary } from '../utils'
import { toDollarCurrencyFormat } from '../../../utils'
import { PdfReadOnlyField } from '../../../../components/pdf/read-only-field'

interface PlantingTypeSummaryType {
  features: FeatureAction[]
  title: string
  subtotalTitle: string
}

export const PlantingTypeSummary = ({ features, title, subtotalTitle }: PlantingTypeSummaryType) => {
  const tablePages = 1
  const data = getPlantingTypeSummary(features)
  const totalCost = getCollectionAggregateForProperty(features, 'proposedCost')

  return (
    <section className='l-section--no-break-inside l-pdf-container--margin-small'>
      <Heading level={3} className='c-field__heading--margin-small'>
        {title}
      </Heading>
      <Table
        tableData={data}
        showResultsCount={false}
        totalResults={data.length}
        totalPages={tablePages}
        setPage={() => tablePages}
        currentPage={tablePages}
        columnHeaders={[
          {
            elementKey: 'action',
            columnHeading: 'Actions',
            viewColumn: 'action',
            sortable: false,
            type: 'text',
          },
          {
            elementKey: 'quantity',
            columnHeading: 'Quantity',
            viewColumn: 'quantity',
            sortable: false,
            type: 'text',
          },
          {
            elementKey: 'estimatedCost',
            columnHeading: 'Estimated Cost ($)',
            viewColumn: 'estimatedCost',
            sortable: false,
            type: 'text',
          },
        ]}
      />
      <PdfReadOnlyField fieldName={subtotalTitle} value={toDollarCurrencyFormat(totalCost)} />
    </section>
  )
}
